var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Utilities } from "../classes/Utilities";
var Pagination = /** @class */ (function () {
    function Pagination() {
        this.selectors = {
            container: '[data-pagination-container]',
            item: '[data-pagination-item]',
            loadMoreBtn: '[data-pagination-load-more-btn]',
            amount: '[data-pagination-amount]',
            data: '[data-pagination-data]',
            loadingBarAnimation: '[data-pagination-loading-bar-animation]'
        };
        this.nodeList = {
            loadingBarAnimation: document.querySelectorAll(this.selectors.loadingBarAnimation)
        };
        this.htmlElement = {
            amount: document.querySelector(this.selectors.amount),
            container: document.querySelector(this.selectors.container),
            loadMoreBtn: document.querySelector(this.selectors.loadMoreBtn),
            data: document.querySelector(this.selectors.data)
        };
        this.className = {
            hidden: 'hidden'
        };
        this.modules = null;
    }
    ;
    Pagination.prototype.init = function (modules) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.htmlElement.container)
                            return [2 /*return*/];
                        this.modules = modules;
                        this.data = this.setData();
                        return [4 /*yield*/, this.prependPreviousPages()];
                    case 1:
                        _a.sent();
                        this.addEventListeners();
                        this.updateUI();
                        return [2 /*return*/];
                }
            });
        });
    };
    Pagination.prototype.setData = function () {
        var params = new URLSearchParams(window.location.search);
        var currentPage = parseInt(params.get('page'));
        return {
            currentPage: currentPage ? currentPage : 1,
            nextPage: currentPage ? currentPage + 1 : 2,
            previousPage: currentPage ? currentPage - 1 : null,
            count: parseInt(this.htmlElement.data.dataset.items)
        };
    };
    Pagination.prototype.addEventListeners = function () {
        this.htmlElement.loadMoreBtn.addEventListener('click', this.handleLoadMoreBtnClick.bind(this));
        this.htmlElement.loadMoreBtn.addEventListener("click", this.removeUnderscores.bind(this));
    };
    Pagination.prototype.removeUnderscores = function () {
        setTimeout(function () {
            var text = document.querySelectorAll(".hyphen_text");
            text.forEach(function (a) {
                if (a !== undefined || a !== null) {
                    a.innerHTML = a.innerHTML.split("_").join(" ");
                }
            });
        }, 700);
        console.log('underscores removed');
    };
    Pagination.prototype.handleLoadMoreBtnClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('loading');
                        return [4 /*yield*/, this.appendNextPage()];
                    case 1:
                        _a.sent();
                        this.updateUI();
                        return [2 /*return*/];
                }
            });
        });
    };
    Pagination.prototype.prependPreviousPages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var page, items, _i, _a, item;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.data.currentPage > 1)) return [3 /*break*/, 5];
                        page = this.data.previousPage;
                        _b.label = 1;
                    case 1:
                        if (!(page > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getPageItems(page)];
                    case 2:
                        items = _b.sent();
                        for (_i = 0, _a = Array.from(items); _i < _a.length; _i++) {
                            item = _a[_i];
                            this.htmlElement.container.prepend(item);
                        }
                        ;
                        _b.label = 3;
                    case 3:
                        page--;
                        return [3 /*break*/, 1];
                    case 4:
                        this.modules.lazyLoader.update();
                        _b.label = 5;
                    case 5:
                        ;
                        return [2 /*return*/];
                }
            });
        });
    };
    Pagination.prototype.appendNextPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items, _i, _a, item, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        console.log('nextpage');
                        return [4 /*yield*/, this.getPageItems(this.data.nextPage++)];
                    case 1:
                        items = _b.sent();
                        console.log('awaited', items);
                        for (_i = 0, _a = Array.from(items); _i < _a.length; _i++) {
                            item = _a[_i];
                            this.htmlElement.container.append(item);
                            console.log(item);
                        }
                        ;
                        this.modules.lazyLoader.update();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Pagination.prototype.getPageItems = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var pathname, path, response, doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pathname = window.location.pathname;
                        console.log('pathname', pathname);
                        path = window.location.search ? "".concat(pathname).concat(window.location.search, "&&page=").concat(page) : "".concat(pathname, "?page=").concat(page);
                        console.log('path', path);
                        return [4 /*yield*/, Utilities.Request.get(path)];
                    case 1:
                        response = _a.sent();
                        console.log('resppnse', response);
                        return [4 /*yield*/, Utilities.Request.parseDOM(response)];
                    case 2:
                        doc = _a.sent();
                        console.log(doc, 'here');
                        return [2 /*return*/, doc.querySelectorAll(this.selectors.item)];
                }
            });
        });
    };
    Pagination.prototype.updateUI = function () {
        var items = document.querySelectorAll(this.selectors.item);
        var percentage = (((items.length / this.data.count) * 100) / 100).toFixed(2);
        this.htmlElement.amount.innerText = items.length.toString();
        if (items.length === parseInt(this.htmlElement.data.dataset.items)) {
            this.htmlElement.loadMoreBtn.classList.add(this.className.hidden);
        }
        ;
        for (var _i = 0, _a = Array.from(this.nodeList.loadingBarAnimation); _i < _a.length; _i++) {
            var loadingBarAnimation = _a[_i];
            var previousTo = loadingBarAnimation.getAttribute('to');
            loadingBarAnimation.setAttribute('from', previousTo);
            loadingBarAnimation.setAttribute('to', percentage.toString());
            loadingBarAnimation.beginElement();
        }
        ;
    };
    return Pagination;
}());
export { Pagination };
;
